// ======================================================================
// File Name       : ServiceGroupRegisterEdit
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import FormControlValidate from '../FormControlValidate';

class ServiceGroupRegisterEdit extends Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  onInputChange({ target }) {
    const { name, value } = target;
    this.props.handleInputChange(name, value);
  }

  render() {
    const { groupBySecernId, editingServiceGroup } = this.props;
    const { serviceGroupName, serviceGroupSecernId } = editingServiceGroup;
    this.refsToValidate = [];
    return (
      <div>
        <Form className='form-horizontal'>
          {serviceGroupSecernId && (
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                サービスグループID
              </Col>
              <Col as={Form.Label} sm={9}>
                {serviceGroupSecernId}
              </Col>
            </Form.Group>
          )}
          <Form.Group className="form-info padding-right-15">
            <Col as={Form.Label} sm={3}>
              サービスグループ名 <span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={9}>
              <FormControlValidate
                name="serviceGroupName"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                required
                maxLength="256"
                value={serviceGroupName}
                onChange={this.onInputChange}
                label="サービスグループ名"
              />
            </Col>
          </Form.Group>

        </Form>
      </div>
    );
  }
}

ServiceGroupRegisterEdit.propTypes = {
  editingServiceGroup: PropTypes.shape().isRequired,
  handleInputChange: PropTypes.func.isRequired,
};

export default ServiceGroupRegisterEdit;
